import { INode } from "../types/INode"

import { Finder, IFinder } from "../finder/IFinder"


export interface IPrj extends INode {
    type:string;
    version:number;
    _id:string|undefined

    parent_id:string
    idn:string;
    fnd:string;
    del:number;

    handlowiec: IFinder;
    klient: IFinder;
    klient_kontakt: IFinder;
    
    handlowiec_tmp:string;
    klient_tmp:string;
    klient_kontakt_tmp:string;

    tagi:string 
    uwagi:string
    file_names:string[]
    labels: any;
    _err:any;

    groups: any[];
}
  
export class Prj implements IPrj {
    type:string="prj";
    version:number=0;
    _id:string|undefined = undefined;
    parent_id:string=""
    idn:string = "";
    fnd:string=""
    del:number=0

    handlowiec: IFinder = new Finder();
    klient: IFinder = new Finder();
    klient_kontakt: IFinder = new Finder();

    handlowiec_tmp:string="";
    klient_tmp:string="";
    klient_kontakt_tmp:string="";

    tagi=""
    uwagi=""
    file_names:string[]=[]
    labels: any = {}
    _err:any={}

    groups: any[]=[];

}

